<template>
  <button>
    <router-link :to="videoPage">
      <svg width="85%" height="100%" viewBox="0 0 33 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <!-- Generator: Sketch 52.6 (67491) - http://www.bohemiancoding.com/sketch -->
        <title>Watch Shiur</title>
        <desc>Created with Sketch.</desc>
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="shiur-card-video" transform="translate(1.000000, 2.000000)" fill="#FFAF14" stroke="#FFAF14" stroke-width="2.40816">
            <rect id="Rectangle" x="0.9077" y="0.1684" width="19.0933" height="18.6633" rx="2.40816"></rect>
            <polygon id="Path" stroke-linejoin="round" points="29.8059 3.1786 23.3555 9.5 29.8059 15.8214"></polygon>
          </g>
        </g>
      </svg>
    </router-link>
  </button>
</template>
<script>
import { mapState } from 'vuex';
export default {
  props: ['shiurim', 'magidShiur', 'type', 'hideText'],
  computed: {
    videoPage: function () {
      return {
        name: 'shiur-video',
        params: {
          id: this.shiurim.id,
        },
      };
    },
  },
};
</script>
<style scoped>
button i.fa-play {
  margin-left: 2.5px;
}
</style>
